import React from 'react'
import type { GatsbyBrowser } from 'gatsby'
import { RootLayout } from './src/components/layout/root-layout'
import '@fontsource-variable/manrope'
import './src/app-globals.css'

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element }) => (
  <RootLayout>{element}</RootLayout>
)
